<div class="wheel-tire-services-container">
  <mic-breadcrumb id="wheel-tire-services-breadcrumb">
    <mic-breadcrumb-link link="/home/dashboard" icon="home"></mic-breadcrumb-link>
    <mic-breadcrumb-link label="{{ translationService.translate('productDataText') }}"></mic-breadcrumb-link>
    <mic-breadcrumb-link label="{{ translationService.translate('wheelAndTireServicesText') }}"></mic-breadcrumb-link>
  </mic-breadcrumb>

  <h2 class="page-title wheel-tire-heading" id="wheel-tire-heading">
    {{ translationService.translate('wheelAndTireServicesText') || 'Wheel and Tire Services' }}
  </h2>

  <mat-tab-group id="wheel-tire-tabs" mat-stretch-tabs="false" class="wheel-tire-tabs" (selectedTabChange)="onTabChange($event)">
    <!-- Wheels Tab -->
    <mat-tab id="wheels-tab" label="{{ translationService.translate('wheelsText') || 'Wheels' }}">
      <div class="tab-panel">
        <app-wheels></app-wheels>
      </div>
    </mat-tab>

    <!-- Wheel Color Tab -->
    <mat-tab id="wheel-color-tab" label="{{ translationService.translate('wheelColorText') || 'Wheel Color' }}">
      <div class="tab-panel">
        <app-wheel-color></app-wheel-color>
      </div>
    </mat-tab>

    <!-- Misc. Charges Setup Tab (placeholder) -->
    <mat-tab id="misc-charges-tab" label="{{ translationService.translate('miscChargesSetupText') || 'Misc. Charges Setup' }}" disabled>
      <div class="tab-panel">
        <p>{{ translationService.translate('comingSoonText') || 'Coming soon...' }}</p>
      </div>
    </mat-tab>

    <!-- Master Charges Tab (placeholder) -->
    <mat-tab id="master-charges-tab" label="{{ translationService.translate('masterChargesText') || 'Master Charges' }}" disabled>
      <div class="tab-panel">
        <p>{{ translationService.translate('comingSoonText') || 'Coming soon...' }}</p>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>
